var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sso"}},[_vm._v(" MC Remoteにログインしています。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }